    <div *ngIf="selectedRefDoc || claimReference.alreadyExists" style="margin-bottom: 10px">

        <div class="reference-text-container">
            <!-- implicit references display ref doc name (ref citation text is not sent for them) -->
            <textarea *ngIf="isImplicit; else explicitReferenceText" pTextarea type="text" [placeholder]="'translate.claims-view.references' | translate" size="32" class="t-input"
            [ngModel]="claimReference.refPhraseText" [readonly]="true"></textarea>
            <ng-template #explicitReferenceText>
                <textarea pTextarea type="text" [placeholder]="'translate.claims-view.references' | translate" size="32" class="t-input" [(ngModel)]="claimReference.refPhraseText"
                [readonly]="mode == 'view'"></textarea>
            </ng-template>
            <div *ngIf="mode !== 'view'" class="remove-link">
                <a title="{{ 'translate.create-claim.removeReference' | translate }}" (click)="removeReference()"><i class="fas fa-minus"></i></a>
            </div>
        </div>
        <div *ngIf="claimReference.anchors && claimReference.anchors.length" class="anchors-container">

            <mng-anchors [anchors]="claimReference.anchors" [phrase]="undefined"
                (anchorToRemove)="removedAnchor()"
                [editAnchorsPaths]="false"
                [displayActions]="mode !== 'view'">

            </mng-anchors>
        </div>
        <div *ngIf="mode !== 'view' && selectedRefDoc" class="add-anchor-link">
            <a (click)="toggleAnchorsDisplay()" class="btn btn-link t-small">
                <i [ngClass]="showAddContextDropdown.value ? 'fas fa-minus': 'fas fa-plus'"></i>
        
                {{ "translate.general.addAnchor" | translate }}
            </a>
        </div>

        <ng-container *ngIf="mode !== 'view' && selectedRefDoc && showAddContextDropdown.value">
                <add-anchor [mode]="'claim-form'" [claimReference]="claimReference"
                [selectedRefDoc]="selectedRefDoc"
                [layoutClass]="'claim-form-anchor-background'"
                [showAddContextDropdown]="showAddContextDropdown" [curDoc]="{ catVersionId: catVersionId }">

                </add-anchor>
        </ng-container>    
    </div>



<div *ngIf="(mode == 'create' && !selectedRefDoc) || (mode == 'edit' && !claimReference.alreadyExists && !selectedRefDoc)" class="select-ref-doc-container">
    <p-select [options]="filteredRefDocs" optionLabel="docName" 
    
        [placeholder]="'translate.general.selectRefDoc' | translate" [(ngModel)]="selectedRefDoc"
         appendTo="body" panelStyleClass="ref-doc-dropdown-panel"
         (onChange)="onRefDocSelect()"
        [style]="{'width': '100%'}">
        <ng-template let-doc pTemplate="selectedItem">
            <span [pTooltip]="doc.docName" tooltipPosition="top"
                style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;">{{
                doc.docName }}</span>
        </ng-template>
        <ng-template let-doc pTemplate="item">
            <span [pTooltip]="doc.docName" tooltipPosition="top"
                style="display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;">{{
                doc.docName }}</span>
        </ng-template>
    </p-select>
    <a title="{{ 'translate.create-claim.removeReference' | translate }}" (click)="removeReference()"><i class="fas fa-minus"></i></a>


</div>
